import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Modal, Input as AntInput } from 'antd';
import PropTypes from 'prop-types';
import Input from '../../../../components/elements/input/Input';
import { sendUserNotification } from '../../api/notificationsApi';

const initialForm = {
  pushTitle: '',
  pushBody: '',
  historyTitle: '',
  historyBody: '',
};

const SendNotificationModal = ({ isOpen, onClose, user }) => {
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const recipientLabel =
    `${user?.firstName || ''} ${user?.lastName || ''}`.trim() ||
    user?.email ||
    user?.phone ||
    '-';

  useEffect(() => {
    if (isOpen) {
      setForm(initialForm);
      setError('');
      setSuccessMessage('');
      setDone(false);
      setLoading(false);
    }
  }, [isOpen, user?._id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleOk = useCallback(async () => {
    if (!user?._id) {
      setError('Korisnik nije izabran.');
      return;
    }

    const payload = {
      pushTitle: form.pushTitle?.trim() || '',
      pushBody: form.pushBody?.trim() || '',
      historyTitle: form.historyTitle?.trim() || '',
      historyBody: form.historyBody?.trim() || '',
    };

    if (
      !payload.pushTitle ||
      !payload.pushBody ||
      !payload.historyTitle ||
      !payload.historyBody
    ) {
      setError('Unesite sva polja notifikacije.');
      return;
    }

    setLoading(true);
    setError('');
    setSuccessMessage('');

    const { ok, message } = await sendUserNotification(user._id, payload);

    if (!ok) {
      setError(message);
      setLoading(false);
      return;
    }

    setSuccessMessage(message || 'Notifikacija poslata.');
    setDone(true);
    setTimeout(() => {
      setDone(false);
      onClose();
    }, 1000);
    setLoading(false);
  }, [
    form.historyBody,
    form.historyTitle,
    form.pushBody,
    form.pushTitle,
    onClose,
    user?._id,
  ]);

  const handleCancel = () => {
    setForm(initialForm);
    setError('');
    setSuccessMessage('');
    setDone(false);
    onClose();
  };

  return (
    <Modal
      className="send_notification_modal"
      title="Pošalji notifikaciju"
      open={isOpen}
      onCancel={handleCancel}
      footer={[
        <Button
          key="send"
          type="primary"
          onClick={handleOk}
          disabled={loading || done}
          style={{ width: '150px' }}
        >
          {loading ? (
            <img
              src="/assets/icons/add.svg"
              alt="Učitavanje"
              className="animate-spin"
            />
          ) : done ? (
            <img
              src="/assets/icons/check.svg"
              alt="Done"
              className="check-icon"
            />
          ) : (
            'Pošalji'
          )}
        </Button>,
      ]}
    >
      <div autoComplete="off">
        <div style={{ marginBottom: 12 }}>
          <strong>Korisnik:</strong> {recipientLabel}
        </div>
        <Input
          label="Šifrovani naslov"
          id="pushTitle"
          name="pushTitle"
          placeholder="Šifrovani naslov"
          value={form.pushTitle}
          onChange={handleChange}
        />
        <div style={{ marginTop: 12 }}>
          <AntInput.TextArea
            rows={4}
            name="pushBody"
            placeholder="Šifrovani opis"
            value={form.pushBody}
            onChange={handleChange}
          />
        </div>
        <div style={{ marginTop: 12 }}>
          <Input
            label="Detaljan naslov"
            id="historyTitle"
            name="historyTitle"
            placeholder="Detaljan naslov"
            value={form.historyTitle}
            onChange={handleChange}
          />
        </div>
        <div style={{ marginTop: 12 }}>
          <AntInput.TextArea
            rows={4}
            name="historyBody"
            placeholder="Detaljan opis"
            value={form.historyBody}
            onChange={handleChange}
          />
        </div>
        {successMessage && (
          <Alert
            title={successMessage}
            type="success"
            showIcon
            style={{ marginTop: 16 }}
          />
        )}
        {error && (
          <Alert
            title={error}
            type="error"
            showIcon
            style={{ marginTop: 16 }}
          />
        )}
      </div>
    </Modal>
  );
};

SendNotificationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  user: PropTypes.object,
};

export default SendNotificationModal;
